// extracted by mini-css-extract-plugin
module.exports = {"margin":"styles_margin__2K7Kd","selection_picker":"styles_selection_picker__1tGg4"};